import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "dacb_cookies_ok";

/**
 * Aviso de cookies/privacidade (LGPD) — simples e NAO bloqueante:
 * barra discreta no canto inferior, sem overlay, sem redirecionamento,
 * sem recarregar a pagina. O conteudo principal renderiza normalmente
 * com o aviso visivel. Ao clicar em "Compreendo", a preferencia fica
 * salva em localStorage e o aviso nao volta a aparecer.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch {
      // storage indisponivel (modo privado restrito): nao exibir
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, new Date().toISOString());
    } catch {
      // sem storage: apenas fecha
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          data-testid="cookie-banner"
          role="dialog"
          aria-live="polite"
          aria-label="Aviso de cookies e privacidade"
          className="fixed inset-x-4 bottom-4 z-[90] border border-[#C5A059]/50 bg-[#2E070D] p-5 shadow-[0_24px_60px_rgba(46,7,13,0.45)] sm:left-auto sm:right-6 sm:max-w-md"
        >
          <p className="overline-label text-[#C5A059]">Privacidade e LGPD</p>
          <p className="mt-2 text-sm leading-relaxed text-[#FBF9F4]/85">
            Utilizamos apenas armazenamento essencial ao funcionamento do portal e métricas anônimas e agregadas de acesso.
            Nenhum dado pessoal é coletado sem necessidade, conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
          </p>
          <button
            data-testid="cookie-accept-button"
            onClick={accept}
            className="overline-label mt-4 bg-[#C5A059] px-6 py-2.5 text-[#2E070D] transition-colors hover:bg-[#D4AF37]"
          >
            Compreendo
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
